import RepController from './rep.controller';
import Template from './rep.html';

export default {
    controller: RepController,
    template: Template
};
